

































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { EntityLocation, FeedTank, Node, Sensor, SensorsApi, Transceiver } from '@/api';
import { FeedProductModals } from '@/pages/account/products/feed/models';

import TransceiverSuggest from '@/components/form pickers/transceiverSuggest.vue';
import SensorSuggest from '@/components/form pickers/sensorSuggest.vue';
import LocationInput from '@/components/form pickers/LocationInput.vue';
import Toast from '@/components/display/toast.vue';
import { EntityLocationService } from '@/services/entity-location-service';
import { Constants } from '@/common/Constants';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';
import NodeSuggest from '@/components/form pickers/nodeSuggest.vue';
import {
	isStrain,
	isRadar,
	SensorType,
} from '@/pages/account/products/feed/models/sensor-config';
@Component({
	components: {
		NodeSuggest,
		SaveCancelButtons,
		TransceiverSuggest,
		SensorSuggest,
		LocationInput,
	},
	methods:{
		isRadar,
	}
})
export default class InstallFeedTankModal extends Vue {
	/** Expose for template. */
	
	@Prop({ required: true, type: Object })
	public feedTank!: FeedTank & {
		/** Radar: single sensor. */
		sensor?: Sensor | null;
		/** Strain: 0 to many sensors. */
		sensors?: Sensor[];
		sensorType: SensorType;
		transceiver: Transceiver | null;
	};

	@Prop({ required: true, type: Function })
	private onInstall!: (feedTank: FeedTank) => Promise<void>;

	@Watch('feedTank')
	public onFeedTankChanged(): void {
		this.resetValues();
	}

	public get transceiverId(): number | null {
		return this.transceiver?.id ?? null;
	}

	public sensorType: SensorType = this.feedTank.sensorType ?? 'radar';
	public transceiver: Partial<Transceiver> | null = this.feedTank.transceiver ?? null;
	public sensor: Sensor | null = this.feedTank.sensor ?? null;
	public node: Node | null = this.feedTank.sensor?.node ?? null;
	/** Strain: selected sensors (from suggested list). */
	public sensorList: Sensor[] = this.feedTank.sensors ?? [];
	/** Strain: sensors offered for selection (by transceiver, type strainGauge). */
	public suggestedSensors: Sensor[] = [];
	public isSuggestedSensorsLoading = false;

	public modalId: string = FeedProductModals.INSTALL_FEED_TANK;

	private toast: Toast = new Toast();
	private readonly sensorsApi = new SensorsApi();


	public async fetchSuggestedSensors(): Promise<void> {
		if (this.transceiverId == null) {
			this.suggestedSensors = [];
			return;
		}
		this.isSuggestedSensorsLoading = true;
		try {
			const response = await this.sensorsApi.getSensors({
				params: {
					include: 'node,transceiver.site',
					'filter[type]': 'strainGauge',
					'filter[transceiverId]': this.transceiverId,
					perPage: 250,
				},
			});
			this.suggestedSensors = response.data.data ?? [];
			// When re-selecting the same transceiver as the tank, preserve the tank's sensors as selected
			const isSameTransceiverAsTank = this.transceiverId === this.feedTank.transceiver?.id;
			const sourceList =
				isSameTransceiverAsTank && (this.feedTank.sensors?.length ?? 0) > 0
					? this.feedTank.sensors
					: this.sensorList;
			const selectedIds = new Set(sourceList.map((s) => s?.id));
			this.sensorList = this.suggestedSensors.filter((s) => selectedIds.has(s.id));
		} catch (e) {
			console.error(e);
			this.suggestedSensors = [];
		} finally {
			this.isSuggestedSensorsLoading = false;
		}
	}

	public onTransceiverChanged(transceiver: Partial<Transceiver> | null): void {
		if (transceiver === null) {
			this.sensor = null;
			this.sensorList = [];
			this.suggestedSensors = [];
		} else if (isStrain(this.sensorType)) {
			this.fetchSuggestedSensors();
		}
	}

	public async installFeedTank(): Promise<void> {
		if (!this.transceiver) {
			this.toast.makeToast('You must select a transceiver', 'Error', 'danger');
			return;
		}
		if (isRadar(this.sensorType) && this.sensor === null) {
			this.toast.makeToast('You must select a sensor', 'Error', 'danger');
			return;
		} else if (isStrain(this.sensorType) && this.sensorList.length === 0) {
			this.toast.makeToast('You must select at least one sensor', 'Error', 'danger');
			return;
		}
	
		this.feedTank.sensor = this.sensor ?? null;
		this.feedTank.sensors = isStrain(this.sensorType)
			? this.sensorList
			: this.sensor != null ? [this.sensor] : [];
		this.feedTank.transceiver = this.transceiver;
		await this.onInstall(this.feedTank);
	}

	public dismiss(): void {
		this.$bvModal.hide(FeedProductModals.INSTALL_FEED_TANK);
	}

	private resetValues(): void {
		this.transceiver = this.feedTank.transceiver ?? null;
		this.sensorType = this.feedTank.sensorType ?? 'radar';
		this.sensor = this.feedTank.sensor ?? null;
		this.node = this.feedTank.sensor?.node ?? null;
		this.sensorList = this.feedTank.sensors ?? [];
		this.suggestedSensors = [];
		if (isStrain(this.sensorType) && this.transceiverId != null) {
			this.fetchSuggestedSensors();
		}
	}
}
